<template>
  <Drawer :closable="false" v-model="customerDetailsDrawer" width="1000" :title="$t('key1003136')" :transfer="false"
    class-name="customerDetailslStyle" @on-visible-change="customerDetailsDrawerChange">
    <template #header>
      <div class="flex align-items-center">
        <Icon type="md-arrow-round-forward" color="#2D8CF0" :size="28" class="cursor"
          @click="customerDetailsDrawer = false"/>
        <h2 class="font-size-17 font-weight-bold ml10">{{ $t('key1003136') }}</h2>
      </div>
    </template>
    <!--tab栏区域-->
    <div class="tab_box_style">
      <Tabs v-model="customerTab" :animated="false">
        <!--客户信息-->
        <TabPane :label="$t('key1003137')" name="customerInfo">
          <Form ref="customerInfoForm" :model="customerInfoForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
            <!--客户基本信息-->
            <div class="basic_information_box">
              <Card :bordered="false" dis-hover>
                <template #title>
                  <h2 class="title_box">{{ $t('key1003159') }}</h2>
                </template>
                <Row type="flex" :gutter="gutterItem">
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003138')" prop="ymsMerchantId">
                      <span class="basic_txt">{{ customerInfoForm.ymsMerchantId || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003098')" prop="name">
                      <span class="basic_txt pt1">{{ customerInfoForm.name || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003100')" prop="userMobile">
                      <span class="basic_txt pt1">
                        {{ customerInfoForm.userMobile ? mobileCountryCode + ' ' + customerInfoForm.userMobile : '-' }}
                      </span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1000068')" prop="userEmail">
                      <span class="basic_txt">{{ customerInfoForm.userEmail || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1001175')">
                      <span class="basic_txt">{{ customerInfoForm.phone || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <Form-item :label="$t('key1003104')" prop="ymsDistributorMerchantGradeId">
                      <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">
                        {{ customerInfoForm.ymsDistributorMerchantGradeName || '-' }}
                      </span>
                      <Select v-else v-model="customerInfoForm.ymsDistributorMerchantGradeId" filterable transfer class="width_260">
                        <Option v-for="(item, index) in customerGradeList" :value="item.ymsDistributorMerchantGradeId" :key="index">{{ item.name }}</Option>
                      </Select>
                    </Form-item>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003106')" prop="customerTypeName" class="radio_styles">
                      <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ customerInfoForm.customerTypeName || '-' }}</span>
                      <RadioGroup v-else v-model="customerInfoForm.merchantType">
                        <Radio label="YMS">{{ $t('key1003107') }}</Radio>
                        <Radio label="ALIGJ">{{ $t('key1003108') }}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003139')" prop="registerSource">
                      <span class="basic_txt">{{ customerInfoForm.registerSourceName || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003102')" prop="currency">
                      <span class="basic_txt">{{ customerInfoForm.currency }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003140')" prop="ymsRelateMerchantList">
                      <span class="basic_txt">{{ customerInfoForm.ymsRelateMerchantList }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003141')" prop="customerAllottedBy">
                      <span class="basic_txt">{{ customerInfoForm.customerAllottedBy || '-' }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1001495')" prop="remark" class="remark_styles">
                      <span v-if="customerDetailsType === 'look'" class="remark_txt">{{ customerInfoForm.remark || '-' }}</span>
                      <Input v-else type="textarea" :placeholder="$t('key1003142')" v-model.trim="customerInfoForm.remark"
                        class="width_260" :autosize="{ minRows: 4, maxRows: 8}"></Input>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol" v-if="showProductWholesaleModel">
                    <FormItem :label="$t('key1003103')" prop="distributorType" class="radio_styles">
                      <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ customerInfoForm.distributorTypeName }}</span>
                      <RadioGroup v-else v-model="customerInfoForm.distributorType">
                        <Radio v-for="item in businessTypeList" :label="item.value">{{ item.name }}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                </Row>
              </Card>
            </div>
            <!--客户财务信息-->
            <div class="basic_information_box">
              <Card :bordered="false" dis-hover>
                <template #title>
                  <h2 class="title_box">{{ $t('key1003160') }}</h2>
                </template>
                <Row type="flex" :gutter="gutterItem">
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003143')" prop="balanceValue">
                      <span class="basic_txt">{{ customerInfoForm.balanceValue }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003144')" prop="withholdingAmountValue">
                      <span class="basic_txt">{{ customerInfoForm.withholdingAmountValue }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003145')" prop="distributorInitialQuota">
                      <div class="flex align-items-center" v-if="customerDetailsType === 'edit'">
                        <InputNumber
                          style="width: 110px;"
                          :min="0"
                          :max="999999999"
                          :formatter="(value) => formatterNumber(value, 2)"
                          v-model="customerInfoForm.distributorInitialQuota"/>
                        <span class="ml7 basic_txt">{{ customerInfoForm.currency || currencyState }}</span>
                      </div>
                      <span v-else class="basic_txt">{{ customerInfoForm.distributorInitialQuotaValue }}</span>
                    </FormItem>
                  </Col>
                  <Col :span="ItemCol">
                    <FormItem :label="$t('key1003146')" prop="distributorUsedQuotaValue">
                      <span class="basic_txt">{{ customerInfoForm.distributorUsedQuotaValue }}</span>
                    </FormItem>
                  </Col>
                </Row>
              </Card>
            </div>
            <!--客户仓库权限-->
            <div class="basic_information_box" v-if="['look', 'edit'].includes(customerDetailsType)">
              <Card :bordered="false" dis-hover>
                <template #title>
                  <h2 class="title_box">{{ $t('key1003161') }}</h2>
                </template>
                <div class="font-size-12" v-if="customerDetailsType === 'look'">{{ warehouseNameList.join('、') }}</div>
                <CheckboxGroup v-else class="checkbox_group_box" v-model="customerInfoForm.ymsDistributorWarehouseOperList">
                  <Checkbox v-for="item in warehouseList" :label="item.ymsWarehouseId" :key="item.ymsWarehouseId">{{ item.name }}</Checkbox>
                </CheckboxGroup>
              </Card>
            </div>
            <!--客户API权限-->
            <div class="basic_information_box" v-if="['look', 'edit'].includes(customerDetailsType)">
              <Card :bordered="false" dis-hover>
                <template #title>
                  <h2 class="title_box">{{ $t('key1003162') }}</h2>
                </template>
                <div class="font-size-12" v-if="customerDetailsType === 'look'">{{ customerAPIPermissionsNameList.join('、') }}</div>
                <CheckboxGroup v-else class="checkbox_group_box" v-model="customerAPIPermissionsValues">
                  <Checkbox v-for="item in customerAPIPermissionsList" :label="item.apiId" :key="item.apiId">{{ item.apiName }}</Checkbox>
                </CheckboxGroup>
              </Card>
            </div>
            <!--联系人-->
            <div class="basic_information_box">
              <Card :bordered="false" dis-hover>
                <template #title>
                  <div class="flex align-items-center justify-content-between">
                    <h2 class="title_box">{{ $t('key1002811') }}</h2>
                    <Button type="primary" v-if="customerDetailsType !== 'look'" @click="addContactBtn">{{ $t('key1003163') }}</Button>
                  </div>
                </template>
                <div class="contacts_box" v-for="(item, index) in contactsList" :key="index" :class="customerDetailsType === 'look' ? 'contacts_box_bg' : ''">
                  <div class="flex align-items-center justify-content-between mb20">
                    <h2 class="font-size-14 color-333 font-weight-bold">{{ item.isPrimaryContact ? $t('key1003133') : $t('key1002811') + index }}</h2>
                    <div class="flex align-items-center" v-if="customerDetailsType !== 'look'">
                      <span v-if="!item.isPrimaryContact" class="cursor themeColor font-size-13" @click="setAsPrimaryContactPersonBtn(index)">{{ $t('key1003164') }}</span>
                      <Icon v-if="!item.isPrimaryContact" type="ios-trash" size="24" color="#ff3300" class="cursor ml8" @click="deleteContactBtn(index)"/>
                    </div>
                  </div>
                  <Row type="flex" :gutter="gutterItem">
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1002676')" prop="contactName">
                        <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ item.contactName || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003147')" v-model.trim="item.contactName" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1003148')" prop="job">
                        <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ item.job || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003149')" v-model.trim="item.job" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1003100')" prop="userMobile">
                        <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ item.phone ? item.phone : '-' }}</span>
                        <Input v-else type="text" clearable v-model.trim="item.phone" :placeholder="$t('key1003101')" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1000068')" prop="email">
                      <span class="basic_txt"
                        v-if="customerDetailsType === 'look'">{{ item.email || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003150')" v-model.trim="item.email" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1001175')" prop="telephone">
                        <span class="basic_txt" v-if="customerDetailsType === 'look'">{{ item.telephone || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003151')" v-model.trim="item.telephone" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1003152')" prop="weChat">
                        <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ item.weChat || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003153')" v-model.trim="item.weChat" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1003154')" prop="qq">
                        <span class="basic_txt pt1" v-if="customerDetailsType === 'look'">{{ item.qq || '-' }}</span>
                        <Input v-else :placeholder="$t('key1003155')" v-model.trim="item.qq" class="width_260"></Input>
                      </FormItem>
                    </Col>
                    <Col :span="ItemCol">
                      <FormItem :label="$t('key1001495')" prop="remark" class="remark_styles">
                        <span v-if="customerDetailsType === 'look'" class="remark_txt">{{ item.remark || '-' }}</span>
                        <Input v-else type="textarea" :placeholder="$t('key1003142')" v-model.trim="item.remark"
                          class="width_260" :autosize="{ minRows: 4, maxRows: 8}"></Input>
                      </FormItem>
                    </Col>
                  </Row>
                  <Divider v-if="customerDetailsType !== 'look' && index !== contactsList.length - 1"/>
                </div>
              </Card>
            </div>
          </Form>
        </TabPane>
        <!--客户旅程-->
        <TabPane :label="$t('key1003156')" name="customerJourney"
          v-if="getPermission('ymsDistributorMerchant_ymsCustomerInfoFu') && scodeTalg">
          <CheckboxGroup class="checkbox_group_box mt20 ml2" v-model="checkboxs"
            @on-change="(val)=>getCustomerJourneyData(val)">
            <Checkbox v-for="item in checkboxList" :label="item.value" :key="item.value">{{ item.name }}</Checkbox>
          </CheckboxGroup>
          <div class="timeline_box" v-if="timelineList.length >0">
            <Timeline>
              <TimelineItem class="timeline_box_item" v-for="item in timelineList">
                <h2 class="title mb8 font-size-13">{{ item.content }}</h2>
                <p class="text mb8 font-size-12">{{ $t('key1003157') + item.contactTime }}</p>
                <div class="flex font-size-12 color-999">
                  <span>{{ $t('key1001495') + item.remark }}</span>
                  <span class="ml20">{{ $t('key1003158') + item.operatorName }}</span>
                </div>
                <div class="timer_box">
                  <p class="font-size-13">{{ item.createdTimer }}</p>
                  <p class="font-size-12 color-999">{{ item.timer }}</p>
                </div>
              </TimelineItem>
            </Timeline>
          </div>
          <div v-else class="timeline_box flex justify-content-center flex-direction align-items-center">
            <img :src="noContent" width="145" height="auto" alt="no content">
            <div class="font-size-12 mt10">{{ $t('key1003165') }}</div>
          </div>
        </TabPane>
      </Tabs>
      <div class="options_box" v-if="customerTab === 'customerInfo'">
        <template v-if="customerDetailsType === 'look' && getPermission('ymsDistributorMerchant_update')">
          <Button type="primary" @click="customerDetailsType = 'edit'">{{ $t('key1000985') }}</Button>
        </template>
        <template v-else>
          <Button @click="customerDetailsDrawer = false" class="mr15">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="customerDetailsBtn">{{ $t('key1000555') }}</Button>
        </template>
      </div>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {
  getUserNameByUserId, formatterNumber, getEnableWarehouseData, _handleMultilingualFields,
  getAllUsersInfo, getAllCountrysData, getAreaCodeByCountryCode, getDataSetBatchList, getEnumName, getEnumList
} from "@/utils/common";

export default {
  name: "customerDetailsDrawer",
  mixins: [Mixin],
  props: {
    customerGradeList: {
      type: Array,
      default: () => []
    },
    // 是否开启批发模式
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      ItemCol: 12,
      customerTab: 'customerInfo', // customerInfo  customerJourney
      customerDetailsDrawer: false,
      customerDetailsType: 'look',
      customerInfoForm: {
        ymsMerchantId: '', // 编号
        name: '', // 客户名称
        currency: '', // 币种
        ymsRelateMerchantList: '', // 关联商户
        customerAllottedBy: '', // 客户负责人
        registerSourceName: '', // 客户来源
        ymsDistributorMerchantGradeName: '', // 客户等级名称
        remark: '', // 备注
        balanceValue: '', // 余额
        withholdingAmountValue: '', // 预扣金额
        distributorInitialQuota: null,
        ymsDistributorWarehouseOperList: [], // 仓库权限
        userMobile: '', // 手机
        userEmail: '', // 邮箱
        phone: '', // 固定电话
        mobileCountryCode: 'CN',
        merchantType: 'YMS',
        distributorType: 'retail', // 业务类型
      },
      ruleValidate: {
        ymsDistributorMerchantGradeId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003097'), trigger: 'change'}
        ],
        userMobile: [
          {validator: v.validateOverseasMobile(false), trigger: 'blur'}
        ],
        phone: [
          {validator: v.validateFixedTelephone(), trigger: 'blur'}
        ]
      },
      warehouseList: [],
      customerAPIPermissionsList: [],
      customerAPIPermissionsValues: [],
      checkboxs: [0, 1, 2],
      checkboxList: [ // 0.联系记录 1.开通产品记录 2.日志信息
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003129'), value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003130'), value: 1},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003131'), value: 2},
      ],
      timelineList: [],
      customerStatusInfo: {},
      ymsMerchantId: null,
      warehouseNameList: [],
      customerAPIPermissionsNameList: [],
      noContent: require('@/assets/images/noContent.gif'),
      mobileCountryCode: '',
      countrysBasisData: [],
      contactsList: [],
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    scodeTalg() {
      return this.systemEnvironment === 'yms';
    },
    // 业务类型
    businessTypeList() {
      const ENUM_KEY = 'YmsDistributorMerchantDetailDistributorTypeCoreEnum';
      return getEnumList(this.enumList, ENUM_KEY);
    }
  },
  methods: {
    // 初始化数据
    async initCustomerDetailsData(type, ymsMerchantId, value) {
      let v = this;
      v.getCustomerApiPermissionData(ymsMerchantId);
      v.customerDetailsType = type;
      v.ymsMerchantId = ymsMerchantId;
      let enumKeyList = [
        'YmsMerchantRegisterSourceCoreEnum',
        'YmsDistributorMerchantDetailDistributorTypeCoreEnum'
      ];
      v.enumData = await getDataSetBatchList(enumKeyList);
      await getAllCountrysData('en').then((data) => {
        v.countrysBasisData = data;
        // 默认为中国手机号 +86
        v.customerInfoForm.mobileCountryCode = 'CN';
      });
      await getAllUsersInfo().then((data) => {
        v.userInfoList = data;
      });
      await v.getDistributorsInfo(ymsMerchantId, value);
      if (v.scodeTalg) {
        await v.getCustomerInfoFu();
        await v.getCustomerJourneyData();
      }
      // 获取当前已启用的仓库
      await getEnableWarehouseData(1).then((data) => {
        if (data && data.length > 0) {
          v.warehouseList = data;
        }
      });
    },
    formatterNumber,
    // 获取客户的数据
    getDistributorsInfo(ymsMerchantId, value) {
      let v = this;
      v.customerInfoForm = {};
      v.warehouseNameList = [];
      v.axios.get(api.get_ymsDistributorMerchant_id + ymsMerchantId, {loading: value}).then(response => {
        if (response.data.code === 0) {
          v.customerDetailsDrawer = true;
          let data = response.data.datas;
          if (data) {
            data.name = _handleMultilingualFields(data.name);
            // 来源
            data.registerSourceName = getEnumName(v.enumData, 'YmsMerchantRegisterSourceCoreEnum', data.registerSource, 'number');
            // 关联商户
            let ymsRelateMerchantList = data.ymsRelateMerchantList || [];
            data.ymsRelateMerchantList = ymsRelateMerchantList.length > 0 ? ymsRelateMerchantList.join('、') : '-';
            // 客户等级
            if (v.customerGradeList.length > 0) {
              v.customerGradeList.map((item) => {
                if (item.ymsDistributorMerchantGradeId === data.ymsDistributorMerchantGradeId) {
                  data.ymsDistributorMerchantGradeName = item.name;
                }
              });
            }

            // 处理金额数据
            function handleMoney(vlaue, currency) {
              let text = '';
              if (vlaue > 0) {
                text = v.formatCurrency(vlaue) + ' ' + (currency ? currency : v.currencyState);
              } else if (vlaue === 0) {
                text = 0 + ' ' + (currency ? currency : v.currencyState);
              } else {
                text = '-';
              }
              return text;
            }

            let currencyKeys = ['balance', 'withholdingAmount', 'distributorInitialQuota', 'distributorUsedQuota'];
            for (let key in data) {
              if (currencyKeys.includes(key)) {
                data[key + 'Value'] = handleMoney(data[key], data.currency);
              }
            }

            // 仓库权限
            data.ymsDistributorWarehouseOperList = [];
            let ymsDistributorWarehouseOpers = data.ymsDistributorWarehouseOpers || [];
            if (ymsDistributorWarehouseOpers.length > 0) {
              data.ymsDistributorWarehouseOperList = ymsDistributorWarehouseOpers.map((item) => {
                return item.ymsWarehouseId;
              });
              if (data.ymsDistributorWarehouseOperList.length > 0) {
                v.warehouseList.map((item) => {
                  if (data.ymsDistributorWarehouseOperList.includes(item.ymsWarehouseId)) {
                    v.warehouseNameList.push(item.name);
                  }
                });
              }
            }
            // 联系人
            let twoCode = 'CN';
            if (data.ymsUserInfo) {
              data.userId = data.ymsUserInfo.userId;
              data.userMobile = data.ymsUserInfo.mobile;
              data.userEmail = data.ymsUserInfo.email;
              data.phone = data.ymsUserInfo.telephone;

              let areaCode = data.ymsUserInfo.mobileCountryCode;
              v.countrysBasisData.map((item) => {
                if (item.areaCode === areaCode) {
                  v.mobileCountryCode = item.areaCodeName + ' ';
                  twoCode = item.twoCode;
                }
              });
            }
            v.customerInfoForm = data;
            v.customerInfoForm.mobileCountryCode = twoCode;
            // 业务类型
            if (data.ymsDistributorMerchantDetail) {
              let distributorType = data.ymsDistributorMerchantDetail.distributorType || 'retail';
              v.customerInfoForm.distributorTypeName = distributorType === 'retail' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000916') :
                distributorType === 'wholesale' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000921') : '-';
              v.customerInfoForm.distributorType = distributorType;
            }
            // 客户类型
            let ymsMerchantTypeRelations = data.ymsMerchantTypeRelations || [];
            if (ymsMerchantTypeRelations.length > 0) {
              let merchantType = ymsMerchantTypeRelations[0].merchantType;
              v.customerInfoForm.merchantType = merchantType;
              v.ymsMerchantTypeRelationId = ymsMerchantTypeRelations[0].ymsMerchantTypeRelationId;
              v.customerInfoForm.customerTypeName = merchantType === 'YMS' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003107') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003108');
            }
            // 联系人信息
            let ymsMerchantContactList = data.ymsMerchantContactList || [];
            if (ymsMerchantContactList.length > 0) {
              // 将主联系人放在第一位
              v.contactsList = ymsMerchantContactList.sort((a, b) => b.isPrimaryContact - a.isPrimaryContact);
            }
          }
        }
      });
    },
    // 保存
    customerDetailsBtn() {
      let v = this;
      if (!v.customerInfoForm.currency) {
        v.$Modal.warning({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003132'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316')
        });
        return false;
      }
      let list = [];
      let query = {
        ymsDistributorWarehouseOperList: [],
        insertYmsMerchantContactBos: [],
      };
      let keyList = ['userId', 'id', 'phone', 'ymsMerchantId', 'name', 'remark', 'ymsDistributorMerchantGradeId', 'distributorInitialQuota'];
      for (let key in v.customerInfoForm) {
        if (keyList.includes(key)) {
          query[key] = v.customerInfoForm[key];
        }
      }
      query.distributorType = v.customerInfoForm.distributorType;
      query.email = v.customerInfoForm.userEmail;
      query.mobile = v.customerInfoForm.userMobile;
      query.mobileCountryCode = getAreaCodeByCountryCode(v.countrysBasisData, v.customerInfoForm.mobileCountryCode);
      query.saveYmsMerchantTypeRelationBos = [{
        merchantType: v.customerInfoForm.merchantType,
        ymsMerchantTypeRelationId: v.ymsMerchantTypeRelationId
      }];
      let ymsDistributorWarehouseOperList = v.customerInfoForm.ymsDistributorWarehouseOperList || [];
      let ymsDistributorWarehouseOpers = v.customerInfoForm.ymsDistributorWarehouseOpers;
      if (ymsDistributorWarehouseOperList.length > 0) {
        ymsDistributorWarehouseOperList.map((item) => {
          let obj = {};
          if (ymsDistributorWarehouseOpers.length > 0) {
            ymsDistributorWarehouseOpers.map((ele) => {
              if (item === ele.ymsWarehouseId) {
                obj = ele;
              }
            });
          }
          obj.ymsWarehouseId = item;
          list.push(obj);
        });
        query.ymsDistributorWarehouseOperList = list;
      }

      // 校验联系人信息至少要填写一个
      function validateRequiredFields(item) {
        const requiredFields = ['contactName', 'email', 'job', 'phone', 'qq', 'telephone', 'weChat'];
        const filledFields = requiredFields.filter(field => item[field]);
        return filledFields.length > 0;
      }

      if (v.contactsList.length > 0) {
        let isMailbox = v.$regular.isMailbox;
        for (let i = 0; i < v.contactsList.length; i++) {
          let item = v.contactsList[i];
          let txt = item.isPrimaryContact ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003133') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811') + i;
          if (item.email) {
            if (!isMailbox.test(item.email)) {
              v.$Message.error(txt + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003134'));
              return false;
            }
          }
          if (!validateRequiredFields(item)) {
            v.$Message.error(txt + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003135'));
            return false;
          }

          let {
            businessMerchantId, contactName, email, job, phone, qq,
            telephone, weChat, remark, ymsMerchantContactId, isPrimaryContact
          } = item;
          query.insertYmsMerchantContactBos.push({
            businessMerchantId, contactName, email, isPrimaryContact, job, phone, qq,
            telephone, weChat, remark, ymsMerchantContactId
          });
        }
      }

      v.$refs['customerInfoForm'].validate((valid) => {
        if (valid) {
          v.updateCustomerAPIPermissionsData().then(() => {
            v.axios.put(api.put_ymsDistributorMerchant_update, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.customerDetailsType = 'look';
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
                v.$emit('updateData', true);
                v.customerInfoForm = {};
                v.warehouseNameList = [];
                v.contactsList = [];
                setTimeout(() => {
                  v.getDistributorsInfo(v.ymsMerchantId, false);
                  v.getCustomerApiPermissionData(v.ymsMerchantId);
                }, 500);
              }
            });
          });
        }
      });
    },
    // 监听弹窗
    customerDetailsDrawerChange(value) {
      let v = this;
      if (!value) {
        v.warehouseNameList = [];
        v.contactsList = [];
        v.mobileCountryCode = '';
        v.$nextTick(() => {
          v.$refs['customerInfoForm'].resetFields();
        });
      }
    },
    // 获取客户旅程标记信息
    getCustomerInfoFu() {
      let v = this;
      v.customerStatusInfo = {};
      v.axios.get(api.get_ymsDistributorMerchant_ymsCustomerInfoFu_queryCustomerInfoStatusList).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.customerStatusInfo = data;
          }
        }
      });
    },
    // 获取客户旅程的数据
    getCustomerJourneyData(types) {
      let v = this;
      if (v.getPermission('ymsDistributorMerchant_ymsCustomerInfoFu')) {
        v.timelineList = [];
        let query = {
          customerInfoTypes: v.checkboxs || types,
          merchantId: v.ymsMerchantId
        };
        v.axios.post(api.post_ymsDistributorMerchant_ymsCustomerInfoFu, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                item.operatorName = getUserNameByUserId(item.updatedBy, v.userInfoList);
                item.contactTime = item.nextContactDate ? v.$uDate.getDateTime(item.nextContactDate) : '';
                item.createdTimer = v.$uDate.getDateTime(item.createdTime);
                if (item.createdTime) {
                  item.timer = `(${v.$uDate.formatTimeSinceCreation(item.createdTime)})` + v.$uDate.getDateTime(item.createdTime, 'secondTime');
                }
                item.contactResult = Number(item.contactResult);
                item.content = getStatusName(item);
              });
              v.timelineList = data.reverse();

              function getStatusName({contactType, contactResult, status}) {
                let name = [];
                if (Object.keys(v.customerStatusInfo).length > 0) {
                  v.customerStatusInfo.conactTypeList.forEach((i) => {
                    if (i.contactType === contactType && contactType === 2) {
                      name.push(i.name);
                    }
                  });

                  v.customerStatusInfo.logNodeList.forEach((i) => {
                    if (i.contactResult === contactResult) {
                      name.push(i.name);
                    }
                  });
                  v.customerStatusInfo.productNodeList.forEach((i) => {
                    if (i.contactResult === contactResult) {
                      name.push(i.name);
                    }
                  });

                  v.customerStatusInfo.customerInfoStatusList.forEach((i) => {
                    if (i.status === status) {
                      i.childNode.forEach((j) => {
                        if (j.contactResult === contactResult) {
                          name.push(i.name, j.name);
                        }
                      });
                    }
                  });
                  return name.join('、');
                }
              }
            }
          }
        });
      }
    },
    // 添加联系人
    addContactBtn() {
      let obj = {
        contactName: '',
        job: '',
        phone: '',
        email: '',
        telephone: '',
        weChat: '',
        qq: '',
        remark: '',
        isPrimaryContact: 0
      };
      this.contactsList.push(obj);
    },
    // 设为主要联系人
    setAsPrimaryContactPersonBtn(index) {
      this.contactsList.map((item) => {
        item.isPrimaryContact = 0;
      });
      this.contactsList[index].isPrimaryContact = 1;
      this.contactsList = this.contactsList.sort((a, b) => b.isPrimaryContact - a.isPrimaryContact);
      this.$forceUpdate();
    },
    // 删除联系人
    deleteContactBtn(index) {
      this.contactsList.splice(index, 1);
    },
    // 获取客户api权限数据
    getCustomerApiPermissionData(ymsMerchantId) {
      this.customerAPIPermissionsValues = [];
      this.customerAPIPermissionsNameList = [];
      this.axios.get(api.get_ymsMerchantApiOper_query + ymsMerchantId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          data.map((item) => {
            if (item.apiId && item.checked) {
              this.customerAPIPermissionsNameList.push(item.apiName);
              this.customerAPIPermissionsValues.push(item.apiId);
            }
          });
          this.customerAPIPermissionsList = data;
        }
      });
    },
    // 更新客户api权限
    updateCustomerAPIPermissionsData() {
      let query = {
        distributorMerchantId: this.customerInfoForm.ymsMerchantId,
        ymsMerchantApiOperBos: []
      };
      let list = this.customerAPIPermissionsList.filter((item) => {
        return this.customerAPIPermissionsValues.includes(item.apiId);
      });
      if (list.length > 0) {
        list.map((item) => {
          let {apiId, apiMethod, apiName, apiPath} = item;
          query.ymsMerchantApiOperBos.push({
            apiId,
            apiMethod,
            apiName,
            apiPath,
            ymsDistributorMerchantId: this.customerInfoForm.ymsMerchantId
          });
        });
      }
      return new Promise((resolve) => {
        this.axios.post(api.post_ymsMerchantApiOper_insertOrUpdate, query).then(response => {
          if (response.data.code === 0) {
            resolve(true);
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customerDetailslStyle {
  .ivu-tabs-bar {
    margin-bottom: 0;
  }

  .ivu-drawer-header {
    padding: 10px;
  }

  .ivu-drawer-body {
    background-color: #F0F2F5;
    padding: 8px 0;

    .tab_box_style {
      position: relative;

      .options_box {
        display: flex;
        align-items: center;
        position: absolute;
        top: -2px;
        right: 16px;
      }
    }

    .basic_information_box {
      padding: 12px 12px 0 12px;

      .ivu-form-item-required .ivu-form-item-label:before {
        font-size: 13px;
      }

      .title_box {
        color: #333;
        font-size: 17px;
        font-weight: bold;
        background-color: #fff;
      }

      .basic_txt {
        font-size: 12px;
        color: #666;
        display: flex;
        align-items: center;
      }

      .remark_styles {
        .ivu-form-item-content {
          line-height: initial;
        }

        .remark_txt {
          font-size: 12px;
          color: #666;
          vertical-align: bottom;
          position: relative;
          top: 7px;
        }
      }

      .contacts_box {
        padding: 15px 15px 0 15px;
      }

      .contacts_box_bg {
        border-radius: 15px;
        overflow: hidden;
        background-color: #EAEDF2;
        margin-bottom: 35px;

        &:last-child {
          margin-bottom: 20px;
        }
      }
    }

    .checkbox_group_box {
      display: flex;
      flex-wrap: wrap;

      .ivu-checkbox-group-item {
        margin: 0 10px 12px 10px;
      }
    }

    .timeline_box {
      max-height: 750px;
      margin: 0 12px auto;
      padding: 30px 12px 10px 150px;
      background-color: #fff;
      border-radius: 4px;
      overflow-y: auto;

      .timeline_box_item {
        position: relative;

        .timer_box {
          text-align: right;
          position: absolute;
          left: -108px;
          top: 0;
        }
      }
    }
  }

  .reset_select_input {
    width: 100px;
    line-height: 32px;
    height: 32px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 32px;
    }
  }

  .ivu-input-group-prepend {
    background-color: transparent;
  }
}
</style>